// const giftForm = document.getElementById('claimGiftForm');
// const giftButton = giftForm.querySelector('.cart-add-button');
// const minimumQuantity = 2; // Minimum quantity required to claim gift
// const giftProductId = document.querySelector('input[name="id"]').value; // Get the gift product ID

// // Function to check cart and update gift button state
// function updateGiftButtonState() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
//       const giftInCart = cart.items.some(item => item.id == giftProductId);

//       if (totalItems >= minimumQuantity && !giftInCart) {
//         giftButton.disabled = false;
//         giftButton.classList.add('active');
//         giftButton.classList.remove('disabled');
//       } else {
//         giftButton.disabled = true;
//         giftButton.classList.remove('active');
//         giftButton.classList.add('disabled');
//       }
//     })
//     .catch(error => console.error('Error fetching cart:', error));
// }

// // Check initial state when page loads
// updateGiftButtonState();

// // Handle gift form submission
// giftForm.addEventListener('submit', function(e) {
//   e.preventDefault();

//   const formData = {
//     items: [{ id: giftProductId, quantity: 1 }]
//   };

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(formData)
//   })
//   .then(response => response.json())
//   .then(data => {
//     // Refresh cart drawer
//     if (typeof refreshCart === 'function') {
//       refreshCart();
//     } else {
//       location.reload(); // Fallback if no refresh function exists
//     }

//     // Optional: Show success message
//     const successMessage = document.createElement('div');
//     successMessage.classList.add('gift-success-message');
//     successMessage.textContent = 'Gift added to cart!';
//     giftForm.appendChild(successMessage);

//     // Disable the gift button after adding
//     giftButton.disabled = true;
//     giftButton.classList.remove('active');

//     setTimeout(() => {
//       successMessage.remove();
//     }, 800);
//   })
//   .catch(error => {
//     console.error('Error adding gift:', error);
//     // Optional: Show error message
//     const errorMessage = document.createElement('div');
//     errorMessage.classList.add('gift-error-message');
//     errorMessage.textContent = 'Failed to add gift. Please try again.';
//     giftForm.appendChild(errorMessage);

//     setTimeout(() => {
//       errorMessage.remove();
//     }, 800);
//   });
// });

// Add complementary product to the cart
// const handleAddToCart = async (event) => {
//   const button = event.target;
//   const variantId = button.getAttribute("data-variant-id");
//   const parentBox = button.closest(".cmpltr_products__box");

//   try {
//     const response = await fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: 1,
//       }),
//     });

//     const data = await response.json();

//     console.log(`${data.title} has been added to your cart!`);

//     // Hide the parent div
//     if (parentBox) {
//       parentBox.style.display = "none";
//     }

//     // Trigger cart refresh or visibility update
//     if (typeof refreshCart === "function") {
//       refreshCart();
//     } else {
//       updateComplementaryProductsVisibility();
//     }
//   } catch (error) {
//     console.error("An error occurred:", error.message);
//   }
// };

// // Update complementary products visibility based on cart contents
// const updateComplementaryProductsVisibility = async () => {
//   try {
//     const response = await fetch("/cart.js");
//     const cart = await response.json();

//     const cartVariantIds = cart.items.map((item) => item.variant_id);

//     document.querySelectorAll(".cmpltr_products__box").forEach((box) => {
//       const button = box.querySelector(".cmpltr_products__adds");
//       const variantId = button?.getAttribute("data-variant-id");

//       if (variantId && cartVariantIds.includes(parseInt(variantId, 10))) {
//         box.style.display = "none"; // Hide if product is already in cart
//       } else {
//         box.style.display = "flex"; // Show if product is not in cart
//       }
//     });
//   } catch (error) {
//     console.error("Error fetching cart:", error.message);
//   }
// };

// // Attach event listeners to buttons
// const attachEventListeners = () => {
//   document.querySelectorAll(".cmpltr_products__adds").forEach((button) => {
//     button.addEventListener("click", handleAddToCart);
//   });
// };

// // Initialize on page load
// const initializeComplementaryProducts = () => {
//   attachEventListeners();
//   updateComplementaryProductsVisibility();
// };

// document.addEventListener("cart:updated", initializeComplementaryProducts);

// Shopify AJAX API to get the cart details
function updateProgressBar() {
  // Fetch the .crtdrawer_pbar element and retrieve dynamic threshold values
  const progressBarContainer = document.querySelector(".crtdrawer_pbar");
  const firstThreshold = progressBarContainer
    ? parseInt(progressBarContainer.getAttribute("data-ftotal"), 10)
    : 500;
  const firstDiscount = progressBarContainer
    ? parseInt(progressBarContainer.getAttribute("data-fdisc"), 10)
    : 500;
  const secondThreshold = progressBarContainer
    ? parseInt(progressBarContainer.getAttribute("data-stotal"), 10)
    : 1000;
  const secondDiscount = progressBarContainer
    ? parseInt(progressBarContainer.getAttribute("data-sdisc"), 10)
    : 1000;

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const total = cart.total_price / 100;
      const progressBar = document.querySelector(".crtdrawer_progressbar span");
      const messageElement = document.querySelector(".crtdrawer_top_msg");
      const showtheDvalue = document.querySelector(".show_the_dvalue");
      const displayFootermsg = document.querySelector(".sidebar__footer_msg");

      // Ensure elements exist before proceeding
      if (!progressBar || !messageElement) return;

      // for the progressbar
      let discount = 0;
      let progress = 0;
      let message = "";
      // let showtheDiscvalue = "";
      let showtheDiscprice = "";
      let cartTotalfordisc = document.querySelector("[data-carttotal-dval]");
      let crtFordisc = cartTotalfordisc.innerHTML;
      crtFordisc = parseFloat(crtFordisc.replace(/,/g, ''));

      if (total <= firstThreshold) {
        discount = 0;
        progress = (total / firstThreshold) * 100;
        message = `Add ₹${
          firstThreshold - total
        } for <span>${firstDiscount}% Mcash</span>`;
        if (displayFootermsg) {
          displayFootermsg.style.display = "none";
        }
        showtheDiscprice = "";
      } else if (total <= secondThreshold) {
        discount = firstDiscount;
        progress = (total / secondThreshold) * 100;
        message = `Add ₹${
          secondThreshold - total
        } for <span>${secondDiscount}% Mcash</span>`;
        if (displayFootermsg) {
          displayFootermsg.style.display = "flex";
        }
        // showtheDiscvalue = `${firstDiscount}%`;
        showtheDiscprice = (crtFordisc * firstDiscount) / 100;
      } else {
        discount = secondDiscount;
        progress = 100;
        message = `You are eligible for <span>${secondDiscount}% Mcash</span>`;
        if (displayFootermsg) {
          displayFootermsg.style.display = "flex";
        }
        // showtheDiscvalue = `${secondDiscount}%`;
        showtheDiscprice = (crtFordisc * secondDiscount) / 100;
      }

      progressBar.style.width = `${progress}%`;
      messageElement.innerHTML = message;
      if (showtheDvalue) {
        showtheDiscprice = Math.floor(parseFloat(showtheDiscprice) || 0);
        showtheDvalue.innerHTML = `₹${showtheDiscprice}`;
      }

       const crtShptext = document.querySelector(".cart__shipping.text-color--opacity.text-size--small");
      if (crtShptext) {
          crtShptext.remove();
      }

      // get cart quantity total and compare price total
      const cartSubtotalElement = document.querySelector(
        "#AjaxCartSubtotal .cart__total"
      );
      const cartTotalElement = document.querySelector("[data-cart-total]");
      const cartCompareTotalElement = document.querySelector(
        "[data-cart-compartotal]"
      );

      if (cartTotalElement && cartCompareTotalElement) {
        const cartTotalHTML = cartTotalElement.innerHTML.trim();;
        const cartCompareTotalHTML = cartCompareTotalElement.innerHTML.trim();;
        const cartTotalSpan = `<span class="cart-total">${cartTotalHTML}</span>`;
        if (cartTotalHTML !== cartCompareTotalHTML) {
          cartCompareTotalSpan = `<span class="cart-compare-total">${cartCompareTotalHTML}</span>`;
        } else {
          cartCompareTotalSpan = '';
        }
        
        cartSubtotalElement.innerHTML = cartTotalSpan + cartCompareTotalSpan;
      } else {
        console.error(
          "One or both of the source elements ('[data-cart-total]' or '[data-cart-compartotal]') are missing in the DOM."
        );
      }
      
    });
}

// Trigger progress bar update after adding/removing/updating cart items
function triggerCartUpdate() {
  updateProgressBar();
}

// Listen for changes and trigger progress bar updates
document.addEventListener("cart:updated", triggerCartUpdate);

// Recalculate progress after product is added to the cart via AJAX
document.querySelectorAll(".add-to-cart").forEach((button) => {
  button.addEventListener("click", function () {
    triggerCartUpdate();
  });
});
document.querySelectorAll(".button.qty-button").forEach((button) => {
  button.addEventListener("click", function () {
    triggerCartUpdate();
  });
});
document.querySelectorAll(".cart-item__actions a.remove").forEach((button) => {
  button.addEventListener("click", function () {
    triggerCartUpdate();
  });
});

if (typeof CartForm !== "function") {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector("form");

      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        const remove = item.querySelector(".remove");
        if (remove) {
          remove.dataset.href = remove.getAttribute("href");
          remove.setAttribute("href", "");
          remove.addEventListener("click", (e) => {
            triggerCartUpdate();

            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector(".qty");
        if (qty) {
          qty.addEventListener(
            "input",
            debounce((e) => {
              e.preventDefault();
              e.target.blur();
              this.updateCartQty(item, parseInt(qty.value));
            }, 500)
          );
          qty.addEventListener("click", (e) => {
            triggerCartUpdate();

            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add("processing");
      if (this.querySelector(".alert")) {
        this.querySelector(".alert").remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty,
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
        },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.classList.add("alert", "alert--error");
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch("?section_id=helper-cart");
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-count]").textContent;
            });
          document
            .querySelectorAll("[data-header-cart-total")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-total]").textContent;
            });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          const event = new Event("cart-updated");
          this.dispatchEvent(event);
        })
        .catch((e) => {
          let alert = document.createElement("span");
          alert.classList.add("alert", "alert--error");
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove("processing");
        });
    }
  }

  if (typeof customElements.get("cart-form") == "undefined") {
    customElements.define("cart-form", CartForm);
  }
}

if (typeof CartProductQuantity !== "function") {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector(".qty-minus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
      this.querySelector(".qty-plus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
      triggerCartUpdate();
      // initializeComplementaryProducts();
    }
    changeCartInput() {
      setTimeout(() => {
        document
          .getElementById("AjaxCartForm")
          .updateCartQty(
            this.closest("[data-js-cart-item]"),
            parseInt(this.querySelector(".qty").value)
          );
        triggerCartUpdate();
        // initializeComplementaryProducts();
      }, 50);
    }
  }

  if (typeof customElements.get("cart-product-quantity") == "undefined") {
    customElements.define("cart-product-quantity", CartProductQuantity);
  }
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch("?section_id=helper-cart")
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(
          text,
          "text/html"
        );
        const cartFormInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
        const cartSubtotalInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

        const cartItems = document.getElementById("AjaxCartForm");
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-count]").textContent;
        });
        document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-total]").textContent;
        });

        document.getElementById("AjaxCartSubtotal").innerHTML =
          cartSubtotalInnerHTML;
        if (document.querySelector("[data-js-site-cart-sidebar]")) {
          document.querySelector("[data-js-site-cart-sidebar]").show();
        }

        if (document.querySelector("cart-recommendations")) {
          document.querySelector("cart-recommendations").innerHTML = "";
          document
            .querySelector("cart-recommendations")
            .generateRecommendations();
        }
      });
  };
}

// Initial update on page load
triggerCartUpdate();
// initializeComplementaryProducts();
